const arr_dim =function(arr){
    return (arr instanceof Array)?1+ndim(arr[0]):0;
}

const array2canvas = function (arr,c,rng){//array, canvas selector or dom, pick rng [min,max]
    if(!(arr instanceof Array))arr=[arr];
    if(!(arr[0] instanceof Array))arr=[arr];
    if(!(arr instanceof Array) || !(arr[0] instanceof Array)){
        console.warn('Not a matrix for canvas to draw');
        return;
    }
    if(arr[0].length==0){console.warn('No matrix data return');return;}
    if(typeof(c)=='string')c = document.querySelector(c);
    //let c = $(canvas_id)[0];
    let w = arr[0].length,h = arr.length;
        c.width=w,c.height=h;
    let c_data = c.getContext('2d').getImageData(0,0,w,h);
    let arr_info = get_arr_info(arr);
    if(rng instanceof Array){
        if(rng[0]!==undefined)arr_info.min = rng[0];
        if(rng[1]!==undefined)arr_info.max = rng[1];
    }
    let new_p,pos;
    for(let i=0;i<h;i++){
        for(let j=0;j<w;j++){
            pos = (i*w+j)*4;
            new_p = new_v(arr[i][j],arr_info.min,arr_info.max);
            c_data.data[pos] = new_p;
            c_data.data[pos+1] = new_p;
            c_data.data[pos+2] = new_p;
            c_data.data[pos+3] = 255;
        }
    };
    c.getContext('2d').putImageData(c_data,0,0);
    function new_v(c_v,min,max){
        let rng = max - min;
        if(rng<1e-6)return c_v;
        if(c_v<min)return min;//由最小最大值限制c_v的取值
        if(c_v>max)return max;
        if(rng>255 || rng<8){//超范围或者范围过小，拉到255
            return (c_v - min)/rng*255;
        }else{
            if(min<0){
                return c_v - min;
            };
            if(max>255){
                return c_v -(max - 255);
            };
            return c_v;
        }

    }
};

const get_arr_info = function (arr){
    let v_min=Infinity,v_max=-Infinity,sum=0,avg=0,size=0,num=0;
    for(let i=0,len_i=arr.length;i<len_i;i++){
        size = len_i;
        if(Array.isArray(arr[i])){
            for(let j=0,len_j=arr[i].length;j<len_j;j++){
                size = [len_i,len_j];
                num +=1;
                sum += arr[i][j];
                v_min = Math.min(v_min,arr[i][j]);
                v_max = Math.max(v_max,arr[i][j]);
            }
        }else{
            num +=1;
            sum += arr[i];
            v_min = Math.min(v_min,arr[i]);
            v_max = Math.max(v_max,arr[i]);
        }
    };
    avg = sum/num;

    return {min:v_min,max:v_max,sum:sum,size:size,avg:avg};

}

const canvas2array = function (canvas_id,rgbh){
    rgbh = rgbh || 'r';
    let rgb_pos =({'r':0,'g':1,'b':2,'h':3})[rgbh] || 0;
    let c = $(canvas_id)[0];
    let w = c.width,h = c.height;
    let c_data = c.getContext('2d').getImageData(0,0,w,h);
    let res =[];
    let pos;
    for(let i=0;i<h;i++){
        res.push([]);
        for(let j=0;j<w;j++){
            pos = (i*w+j)*4+rgb_pos;
            res[i].push(c_data.data[pos]);//取r
        }
    };
    return res;
}


export {array2canvas,canvas2array,get_arr_info,arr_dim}
